// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimelineModal_modalOverlay__fch9L {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.TimelineModal_modalLarge__Rnr2w {
  background: #fff;
  border-radius: 6px;
  width: 95%;
  max-width: 1000px;
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.TimelineModal_modalHeader__tEpz\\+ {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #ddd;
}

.TimelineModal_smallBtn__z-jCN {
  margin-right: 8px;
  padding: 4px 8px;
}

.TimelineModal_closeButton__WZNl7 {
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
}

.TimelineModal_modalBody__Qsikc {
  padding: 8px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.TimelineModal_hint__wqdOW {
  font-size: 0.85em;
  color: #555;
  margin-bottom: 8px;
}

.TimelineModal_checkbox__yFeFY {
  margin-bottom: 12px;
  display: inline-flex;
  align-items: center;
}

/* Контейнер: левая колонка с подписями и правая с таймлайном */
.TimelineModal_timelineContainer__bOZnM {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

/* Левая колонка */
.TimelineModal_leftColumn__ACcww {
  width: 170px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 30px; /* чтобы совпадало со шкалой времени */
  background: #f9f9f9;
  border-right: 1px solid #ddd;
  overflow-y: hidden; /* фиксированная */
}

.TimelineModal_routeLabelFixed__Ori0O {
  height: 30px;
  line-height: 30px;
  padding-left: 8px;
  font-size: 0.9em;
  color: #333;
}

/* Правая часть со шкалой времени и точками */
.TimelineModal_timelineWrapper__bHVDy {
  position: relative;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 30px; /* место для верхних меток */
  cursor: grab;
}

.TimelineModal_timelineWrapper__bHVDy:active {
  cursor: grabbing;
}

/* Линии и метки на отдельном слое */
.TimelineModal_gridLayer__IxdHh {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  pointer-events: none;
  z-index: 1;
}

.TimelineModal_routesLayer__R8X-L {
  position: relative;
  z-index: 2;
}

/* Полная высота вертикальных линий */
.TimelineModal_gridLineFull__hWJcj {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: #e0e0e0;
  z-index: 1;
}

/* Подписи времени сверху */
.TimelineModal_tickHeader__ynIBx {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  font-size: 0.75em;
  color: #333;
  white-space: nowrap;
  z-index: 2;
}

/* Строка маршрута */
.TimelineModal_routeRow__7I\\+xH {
  display: flex;
  align-items: center;
  height: 30px;
}

/* Область точек (событий) */
.TimelineModal_routeEvents__ihHuA {
  position: relative;
  flex: 1 1;
  height: 100%;
}

/* Событие-точка */
.TimelineModal_marker__jQejj {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  cursor: default;
  z-index: 2;
}

.TimelineModal_marker__jQejj:hover {
  z-index: 1000;
}

/* Tooltip */
.TimelineModal_tooltip__xbuFH {
  display: none;
  position: absolute;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.8);
  color: #fff;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 0.75em;
  white-space: nowrap;
  z-index: 1001;
}

.TimelineModal_marker__jQejj:hover .TimelineModal_tooltip__xbuFH {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/LogisistMainPage/styles/TimelineModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB,EAAE,sCAAsC;EACzD,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB,EAAE,kBAAkB;AACxC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB,EAAE,4BAA4B;EAC/C,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".modalOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.modalLarge {\r\n  background: #fff;\r\n  border-radius: 6px;\r\n  width: 95%;\r\n  max-width: 1000px;\r\n  height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.modalHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.smallBtn {\r\n  margin-right: 8px;\r\n  padding: 4px 8px;\r\n}\r\n\r\n.closeButton {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5em;\r\n  cursor: pointer;\r\n}\r\n\r\n.modalBody {\r\n  padding: 8px;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.hint {\r\n  font-size: 0.85em;\r\n  color: #555;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.checkbox {\r\n  margin-bottom: 12px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Контейнер: левая колонка с подписями и правая с таймлайном */\r\n.timelineContainer {\r\n  display: flex;\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Левая колонка */\r\n.leftColumn {\r\n  width: 170px;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  padding-top: 30px; /* чтобы совпадало со шкалой времени */\r\n  background: #f9f9f9;\r\n  border-right: 1px solid #ddd;\r\n  overflow-y: hidden; /* фиксированная */\r\n}\r\n\r\n.routeLabelFixed {\r\n  height: 30px;\r\n  line-height: 30px;\r\n  padding-left: 8px;\r\n  font-size: 0.9em;\r\n  color: #333;\r\n}\r\n\r\n/* Правая часть со шкалой времени и точками */\r\n.timelineWrapper {\r\n  position: relative;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding-top: 30px; /* место для верхних меток */\r\n  cursor: grab;\r\n}\r\n\r\n.timelineWrapper:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n/* Линии и метки на отдельном слое */\r\n.gridLayer {\r\n  position: absolute;\r\n  top: 0; left: 0; right: 0; bottom: 0;\r\n  pointer-events: none;\r\n  z-index: 1;\r\n}\r\n\r\n.routesLayer {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n/* Полная высота вертикальных линий */\r\n.gridLineFull {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 1px;\r\n  background: #e0e0e0;\r\n  z-index: 1;\r\n}\r\n\r\n/* Подписи времени сверху */\r\n.tickHeader {\r\n  position: absolute;\r\n  top: 0;\r\n  transform: translateX(-50%);\r\n  font-size: 0.75em;\r\n  color: #333;\r\n  white-space: nowrap;\r\n  z-index: 2;\r\n}\r\n\r\n/* Строка маршрута */\r\n.routeRow {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 30px;\r\n}\r\n\r\n/* Область точек (событий) */\r\n.routeEvents {\r\n  position: relative;\r\n  flex: 1;\r\n  height: 100%;\r\n}\r\n\r\n/* Событие-точка */\r\n.marker {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 14px;\r\n  height: 14px;\r\n  border-radius: 50%;\r\n  cursor: default;\r\n  z-index: 2;\r\n}\r\n\r\n.marker:hover {\r\n  z-index: 1000;\r\n}\r\n\r\n/* Tooltip */\r\n.tooltip {\r\n  display: none;\r\n  position: absolute;\r\n  top: 18px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: rgba(0,0,0,0.8);\r\n  color: #fff;\r\n  padding: 6px 8px;\r\n  border-radius: 4px;\r\n  font-size: 0.75em;\r\n  white-space: nowrap;\r\n  z-index: 1001;\r\n}\r\n\r\n.marker:hover .tooltip {\r\n  display: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `TimelineModal_modalOverlay__fch9L`,
	"modalLarge": `TimelineModal_modalLarge__Rnr2w`,
	"modalHeader": `TimelineModal_modalHeader__tEpz+`,
	"smallBtn": `TimelineModal_smallBtn__z-jCN`,
	"closeButton": `TimelineModal_closeButton__WZNl7`,
	"modalBody": `TimelineModal_modalBody__Qsikc`,
	"hint": `TimelineModal_hint__wqdOW`,
	"checkbox": `TimelineModal_checkbox__yFeFY`,
	"timelineContainer": `TimelineModal_timelineContainer__bOZnM`,
	"leftColumn": `TimelineModal_leftColumn__ACcww`,
	"routeLabelFixed": `TimelineModal_routeLabelFixed__Ori0O`,
	"timelineWrapper": `TimelineModal_timelineWrapper__bHVDy`,
	"gridLayer": `TimelineModal_gridLayer__IxdHh`,
	"routesLayer": `TimelineModal_routesLayer__R8X-L`,
	"gridLineFull": `TimelineModal_gridLineFull__hWJcj`,
	"tickHeader": `TimelineModal_tickHeader__ynIBx`,
	"routeRow": `TimelineModal_routeRow__7I+xH`,
	"routeEvents": `TimelineModal_routeEvents__ihHuA`,
	"marker": `TimelineModal_marker__jQejj`,
	"tooltip": `TimelineModal_tooltip__xbuFH`
};
export default ___CSS_LOADER_EXPORT___;
